import { Component } from '@angular/core';

@Component({
  selector: 'ui-page',
  templateUrl: './page.component.html'
})
export class PageComponent {
}